import { useMutation } from '@tanstack/react-query';

import { updateUserPinApi } from '../api';

export default function useUpdateUserPinMutation(config?: any) {
  return useMutation(updateUserPinApi, config);
}
